import React from 'react';
import { format, parseISO } from 'date-fns';
import { usePreApprovalMetrics } from '../context/PreApprovalMetricsContext';
import { Skeleton } from '@/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table';

export function PreApprovalTable() {
  const { byOfficer, isLoading } = usePreApprovalMetrics();

  if (isLoading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    );
  }

  if (byOfficer.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No pre-approvals found in the selected date range
      </div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Loan Officer</TableHead>
            <TableHead className="text-center">Sent</TableHead>
            <TableHead className="text-center">Borrower Views</TableHead>
            <TableHead className="text-center">Partner Views</TableHead>
            <TableHead>Last Sent</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {byOfficer.map((officer) => (
            <TableRow key={officer.loan_officer_id}>
              <TableCell className="font-medium">
                {officer.first_name} {officer.last_name}
              </TableCell>
              <TableCell className="text-center">
                <span className="font-semibold text-blue-600">{officer.sent}</span>
              </TableCell>
              <TableCell className="text-center">
                <span className="font-semibold text-green-600">{officer.borrower_views}</span>
              </TableCell>
              <TableCell className="text-center">
                <span className="font-semibold text-purple-600">{officer.partner_views}</span>
              </TableCell>
              <TableCell className="text-muted-foreground text-sm">
                {officer.last_sent_at
                  ? format(parseISO(officer.last_sent_at), 'MMM d, yyyy h:mm a')
                  : '—'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default PreApprovalTable;
